var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import classNames from "classnames";
import React from "react";
import { Button } from "@riseart/common";
import { artActionButtonCls, artActionButtonLoadingCls } from "./Action.less";
var ArtActionRent = /* @__PURE__ */ __name(function ArtActionRent2(_ref) {
  var buttonText = _ref.buttonText, loading = _ref.loading, onClick = _ref.onClick;
  return /* @__PURE__ */ React.createElement(Button, {
    type: "secondary",
    size: "medium",
    width: "container",
    disabled: loading,
    onClick,
    className: classNames(artActionButtonCls, loading && artActionButtonLoadingCls)
  }, buttonText);
}, "ArtActionRent");
export {
  ArtActionRent
};
